/**
 * @ignore
 * @typedef {object} CustomEvent
 * @property {object} CustomEvent.detail - data passed when initializing the event
 * @property {boolean} CustomEvent.bubbles - A boolean indicating whether or not the event bubbles up through the DOM
 */

/**
 * @ignore
 * @private
 * a wrapper for dispatching custom events for now
 *
 * @param {CustomEvent} customEvent - a native CustomEvent @see {@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEventhttps://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
 */
export default function dispatchCustomEvent(customEvent) {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(customEvent);
  }
}
